module.exports = __webpack_public_path__ + "img/dweddwedwddew.3f211d71.png";